<template>
  <div id="repair-create-before">
    <component v-bind:is="imgComponent" v-bind:repairRecord.sync="repairRecord">
    </component>
  </div>
</template>

<script>
import RepairCreateBeforePicture from './repair-create-before-picture.vue';
import RepairCreateBeforeSwiper from './repair-create-before-swiper.vue';
const img_map = new Map([
  [true, { component: 'RepairCreateBeforePicture' }],
  [false, { component: 'RepairCreateBeforeSwiper' }]
]);
export default {
  components: { RepairCreateBeforePicture, RepairCreateBeforeSwiper },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    imgComponent() {
      const { component } = img_map.get(this.visibleEdit);
      return component;
    }
  }
};
</script>

<style lang="scss"></style>
